import React, { useEffect } from 'react';
import '../styles/back-button.css';
import Text from 'ui/Text';
import ArrowMob from './../../../images/icons/arrowLeft.svg';
import ArrowDesktop from './../../../images/icons/arrowLeftDark.svg';
import { BackArrow } from 'components/big9/styled';
import { browserHistory } from 'react-router';
import { SPILKLUB_URL } from 'features/SpilKlub/screens/useScreens';
import { detectMobile } from '../../../utils/UiHelper';

const BackButton = ({
    className,
    goBackHandler = () => browserHistory.goBack(),
}) => {
    const backImage =
        detectMobile() ||
        window.location.pathname.split('/')[3] === 'createGroup'
            ? ArrowMob
            : ArrowDesktop;

    return (
        window.location.pathname.includes(SPILKLUB_URL) && (
            <div
                className={`sk-back-button ${className} ${
                    (window.location.pathname.split('/')[3] === 'pools' &&
                        !detectMobile()) ||
                    (window.location.pathname.split('/')[3] === 'pool' &&
                        !detectMobile())
                        ? 'isPool'
                        : null
                }`}
                onClick={goBackHandler}
            >
                <BackArrow src={backImage} className={'sk-back-arrow'} />
                <Text size={'x07'} color={'#fff'} padding={'0'}>
                    Tilbage
                </Text>
            </div>
        )
    );
};

export default BackButton;
